export const NFT_STORAGE_ENDPOINT = "https://api.nft.storage/upload";
export const RPC_URL = `https://rinkeby.infura.io/v3/${
  process.env.VUE_APP_ERC721_TOKEN || ""
}`;
export const OPENSEA_BASE_URL = "https://api.opensea.io/api/v1/";
export const BASE_URL =
  process.env.VUE_APP_BASE_URL || "http://localhost:3000/graphql";

export const ERC721_TOKEN = process.env.VUE_APP_ERC721_TOKEN || "";
export const ERC721_FACTORY = process.env.VUE_APP_ERC721_FACTORY || "";
export const EXCHANGE = process.env.VUE_APP_EXCHANGE || "";
